import { useEffect, useState } from "react";
import i18n, { setLanguage, type Lang } from "@/i18n";

export function LanguageSwitcher() {
  const [lang, setLang] = useState<Lang>("en");
  useEffect(() => {
    const update = () => setLang((i18n.language === "nb" ? "nb" : "en") as Lang);
    update();
    i18n.on("languageChanged", update);
    return () => {
      i18n.off("languageChanged", update);
    };
  }, []);

  return (
    <div className="flex items-center text-[10px] font-mono uppercase tracking-widest border border-border rounded-full overflow-hidden">
      <button
        type="button"
        onClick={() => setLanguage("en")}
        aria-label="EN — English"
        aria-pressed={lang === "en"}
        className={
          "px-2.5 py-1 transition-colors " +
          (lang === "en" ? "bg-foreground text-background" : "text-muted-foreground")
        }
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLanguage("nb")}
        aria-label="NB — Norsk bokmål"
        aria-pressed={lang === "nb"}
        className={
          "px-2.5 py-1 transition-colors " +
          (lang === "nb" ? "bg-foreground text-background" : "text-muted-foreground")
        }
      >
        NB
      </button>
    </div>
  );
}
